import { Brand } from './types'

export const brands: Brand[] = [
  // FRAGRANCE BRANDS 1
  {
    id: 'brand-1',
    code: '9127',
    name: 'Chanel',
    contactEmail: 'media@chanel.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-2',
    code: '9094',
    name: 'Lancôme',
    contactEmail: 'media@lancome.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-3',
    code: '9120',
    name: 'Estée Lauder',
    contactEmail: 'media@esteelauder.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-4',
    code: '1198',
    name: 'Bobbi Brown',
    contactEmail: 'media@bobbibrown.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-5',
    code: '9106',
    name: 'Dolce + Gabbana',
    contactEmail: 'media@dolcegabbana.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-6',
    code: '9093',
    name: 'Tom Ford',
    contactEmail: 'media@tomford.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-7',
    code: '9067',
    name: 'Clarins',
    contactEmail: 'media@clarins.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-8',
    code: '7340',
    name: 'Essence',
    contactEmail: 'media@essence.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-9',
    code: '2083',
    name: 'Charlotte Rhys',
    contactEmail: 'media@charlotterhys.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-10',
    code: '1815',
    name: 'Jo Malone London',
    contactEmail: 'media@jomalone.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-11',
    code: '9063',
    name: 'Clinique',
    contactEmail: 'media@clinique.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-12',
    code: '4820',
    name: 'Stila',
    contactEmail: 'media@stila.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-13',
    code: '9107',
    name: 'Gucci',
    contactEmail: 'media@gucci.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-14',
    code: '1781',
    name: 'Giorgio Armani',
    contactEmail: 'media@armani.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-15',
    code: '1801',
    name: 'La Mer',
    contactEmail: 'media@lamer.co.za',
    category: 'Fragrance',
  },

  // FRAGRANCE BRANDS 2
  {
    id: 'brand-16',
    code: '4804',
    name: 'Revlon',
    contactEmail: 'media@revlon.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-17',
    code: '3055',
    name: 'Elie Saab',
    contactEmail: 'media@eliesaab.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-18',
    code: '1665',
    name: 'Versace',
    contactEmail: 'media@versace.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-19',
    code: '3220',
    name: 'Narciso Rodriguez',
    contactEmail: 'media@narcisorodriguez.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-20',
    code: '9153',
    name: 'Hugo Boss',
    contactEmail: 'media@hugoboss.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-21',
    code: '1777',
    name: 'Yves Saint Laurent',
    contactEmail: 'media@ysl.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-22',
    code: '3217',
    name: 'Bvlgari',
    contactEmail: 'media@bvlgari.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-23',
    code: '1657',
    name: 'Paco Rabanne',
    contactEmail: 'media@pacorabanne.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-24',
    code: '9152',
    name: 'Issey Miyake',
    contactEmail: 'media@isseymiyake.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-25',
    code: '1688',
    name: 'Jean Paul Gaultier',
    contactEmail: 'media@jpgaultier.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-26',
    code: '9310',
    name: 'Burberry',
    contactEmail: 'media@burberry.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-27',
    code: '1712',
    name: 'Carolina Herrera',
    contactEmail: 'media@carolinaherrera.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-28',
    code: '9154',
    name: 'Hermès',
    contactEmail: 'media@hermes.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-29',
    code: '1604',
    name: 'Givenchy',
    contactEmail: 'media@givenchy.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-30',
    code: '1580',
    name: 'Mugler',
    contactEmail: 'media@mugler.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-31',
    code: '9326',
    name: 'Coach',
    contactEmail: 'media@coach.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-32',
    code: '8223',
    name: 'Prada',
    contactEmail: 'media@prada.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-33',
    code: '9299',
    name: 'Marc Jacobs',
    contactEmail: 'media@marcjacobs.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-34',
    code: '9382',
    name: 'Molton Brown',
    contactEmail: 'media@moltonbrown.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-35',
    code: '8108',
    name: 'Jimmy Choo',
    contactEmail: 'media@jimmychoo.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-36',
    code: '1676',
    name: 'Michael Kors',
    contactEmail: 'media@michaelkors.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-37',
    code: '8102',
    name: 'Mont Blanc',
    contactEmail: 'media@montblanc.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-38',
    code: '1584',
    name: 'Azzaro',
    contactEmail: 'media@azzaro.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-39',
    code: '8106',
    name: 'Acqua di Parma',
    contactEmail: 'media@acquadiparma.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-40',
    code: '1661',
    name: 'Valentino',
    contactEmail: 'media@valentino.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-41',
    code: '8100',
    name: 'Donna Karan',
    contactEmail: 'media@donnakaran.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-42',
    code: '7335',
    name: 'Antonio Banderas',
    contactEmail: 'media@antoniobanderas.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-43',
    code: '8090',
    name: 'Tommy Hilfiger',
    contactEmail: 'media@tommyhilfiger.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-44',
    code: '9381',
    name: "L'Occitane",
    contactEmail: 'media@loccitane.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-45',
    code: '9378',
    name: 'Calvin Klein',
    contactEmail: 'media@calvinklein.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-46',
    code: '1592',
    name: 'Cartier',
    contactEmail: 'media@cartier.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-47',
    code: '9377',
    name: 'Zadig + Voltaire',
    contactEmail: 'media@zadigvoltaire.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-48',
    code: '1673',
    name: 'Aramis',
    contactEmail: 'media@aramis.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-49',
    code: '7467',
    name: 'Davidoff',
    contactEmail: 'media@davidoff.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-50',
    code: '7399',
    name: 'Victor & Rolf',
    contactEmail: 'media@victorandrolf.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-51',
    code: '8110',
    name: 'Guess',
    contactEmail: 'media@guess.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-52',
    code: '7553',
    name: 'Kenzo',
    contactEmail: 'media@kenzo.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-53',
    code: '7357',
    name: 'Tabac',
    contactEmail: 'media@tabac.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-54',
    code: '3224',
    name: 'Chloé',
    contactEmail: 'media@chloe.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-55',
    code: '7478',
    name: 'Cristiano Ronaldo',
    contactEmail: 'media@cr7.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-56',
    code: '8250',
    name: 'Ariana Grande',
    contactEmail: 'media@arianagrande.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-57',
    code: '8259',
    name: 'Kate Spade',
    contactEmail: 'media@katespade.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-58',
    code: '8342',
    name: 'Loewe',
    contactEmail: 'media@loewe.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-59',
    code: '8088',
    name: 'Nautica',
    contactEmail: 'media@nautica.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-60',
    code: '8336',
    name: 'Maison Margiela',
    contactEmail: 'media@maisonmargiela.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-61',
    code: '8348',
    name: 'Terenzi',
    contactEmail: 'media@terenzi.co.za',
    category: 'Fragrance',
  },
  {
    id: 'brand-62',
    code: '8396',
    name: 'Sol de Janeiro',
    contactEmail: 'media@soldejaneiro.co.za',
    category: 'Fragrance',
  },

  // SKIN BRANDS (540)
  {
    id: 'brand-63',
    code: '7256',
    name: 'Dermalogica',
    contactEmail: 'media@dermalogica.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-64',
    code: '9065',
    name: 'Elizabeth Arden',
    contactEmail: 'media@elizabetharden.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-65',
    code: '7406',
    name: 'Skin Functional',
    contactEmail: 'media@skinfunctional.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-66',
    code: '8218',
    name: 'The Ordinary',
    contactEmail: 'media@theordinary.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-67',
    code: '9141',
    name: 'La Prairie',
    contactEmail: 'media@laprairie.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-68',
    code: '5927',
    name: 'Nuxe',
    contactEmail: 'media@nuxe.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-69',
    code: '2190',
    name: 'Skoon',
    contactEmail: 'media@skoon.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-70',
    code: '9069',
    name: 'Sisley',
    contactEmail: 'media@sisley.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-71',
    code: '9071',
    name: 'Gatineau',
    contactEmail: 'media@gatineau.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-72',
    code: '9142',
    name: 'Dr Hauschka',
    contactEmail: 'media@drhauschka.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-73',
    code: '9117',
    name: 'Sensai',
    contactEmail: 'media@sensai.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-74',
    code: '7324',
    name: 'Bioderma',
    contactEmail: 'media@bioderma.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-75',
    code: '7409',
    name: 'Eucerin',
    contactEmail: 'media@eucerin.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-76',
    code: '7543',
    name: 'Erborian',
    contactEmail: 'media@erborian.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-77',
    code: '8225',
    name: 'Shiseido',
    contactEmail: 'media@shiseido.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-78',
    code: '7537',
    name: 'Lelive',
    contactEmail: 'media@lelive.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-79',
    code: '7321',
    name: 'Uriage',
    contactEmail: 'media@uriage.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-80',
    code: '7551',
    name: 'Motherkind',
    contactEmail: 'media@motherkind.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-81',
    code: '2137',
    name: 'Skin Creamery',
    contactEmail: 'media@skincreamery.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-82',
    code: '3051',
    name: 'Elemis',
    contactEmail: 'media@elemis.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-83',
    code: '8340',
    name: 'Kiehls',
    contactEmail: 'media@kiehls.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-84',
    code: '7531',
    name: 'Origins',
    contactEmail: 'media@origins.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-85',
    code: '7541',
    name: 'Apivita',
    contactEmail: 'media@apivita.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-86',
    code: '8320',
    name: 'Laneige',
    contactEmail: 'media@laneige.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-87',
    code: '7529',
    name: 'Prai',
    contactEmail: 'media@prai.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-88',
    code: '8287',
    name: 'Mary & May',
    contactEmail: 'media@maryandmay.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-89',
    code: '7605',
    name: 'Amazi Skin',
    contactEmail: 'media@amaziskin.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-90',
    code: '8585',
    name: 'COSRX',
    contactEmail: 'media@cosrx.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-91',
    code: '8587',
    name: 'Haruharu',
    contactEmail: 'media@haruharu.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-92',
    code: '8589',
    name: 'Axis Y',
    contactEmail: 'media@axisy.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-93',
    code: '8591',
    name: 'Skin 1004',
    contactEmail: 'media@skin1004.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-94',
    code: '8593',
    name: 'Beauty of Joseon',
    contactEmail: 'media@beautyofjoseon.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-95',
    code: '8619',
    name: 'Barulab',
    contactEmail: 'media@barulab.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-96',
    code: '8621',
    name: 'Mixsoon',
    contactEmail: 'media@mixsoon.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-97',
    code: '8318',
    name: 'Geske',
    contactEmail: 'media@geske.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-98',
    code: '7412',
    name: 'Dose & Co',
    contactEmail: 'media@doseandco.co.za',
    category: 'Skin',
  },
  {
    id: 'brand-99',
    code: '8515',
    name: 'Wrinkles Schminkles',
    contactEmail: 'media@wrinklesschminkles.co.za',
    category: 'Skin',
  },

  // COLOUR BRANDS (541)
  {
    id: 'brand-100',
    code: '7385',
    name: 'Maybelline',
    contactEmail: 'media@maybelline.co.za',
    category: 'Colour',
  },
  {
    id: 'brand-101',
    code: '7372',
    name: "L'Oréal",
    contactEmail: 'media@loreal.co.za',
    category: 'Colour',
  },
  {
    id: 'brand-102',
    code: '9146',
    name: 'Benefit',
    contactEmail: 'media@benefit.co.za',
    category: 'Colour',
  },
  {
    id: 'brand-103',
    code: '7361',
    name: 'Beauty Blender',
    contactEmail: 'media@beautyblender.co.za',
    category: 'Colour',
  },
  {
    id: 'brand-104',
    code: '8617',
    name: 'NYX',
    contactEmail: 'media@nyx.co.za',
    category: 'Colour',
  },
  {
    id: 'brand-105',
    code: '8623',
    name: 'NARS',
    contactEmail: 'media@nars.co.za',
    category: 'Colour',
  },
  {
    id: 'brand-106',
    code: '5413',
    name: 'Morgan Taylor',
    contactEmail: 'media@morgantaylor.co.za',
    category: 'Colour',
  },
  {
    id: 'brand-107',
    code: '7382',
    name: 'Essie',
    contactEmail: 'media@essie.co.za',
    category: 'Colour',
  },
  {
    id: 'brand-108',
    code: '8196',
    name: 'Sphinx',
    contactEmail: 'media@sphinx.co.za',
    category: 'Colour',
  },
  {
    id: 'brand-109',
    code: '7456',
    name: 'Pixi',
    contactEmail: 'media@pixi.co.za',
    category: 'Colour',
  },
  {
    id: 'brand-110',
    code: '8520',
    name: 'Kylie',
    contactEmail: 'media@kylie.co.za',
    category: 'Colour',
  },
  {
    id: 'brand-111',
    code: '8210',
    name: 'Yardley',
    contactEmail: 'media@yardley.co.za',
    category: 'Colour',
  },

  // HAIRCARE & OTHER
  {
    id: 'brand-112',
    code: '7643',
    name: 'Haircare',
    contactEmail: 'media@haircare.co.za',
    category: 'Haircare',
  },
  {
    id: 'brand-113',
    code: '8405',
    name: 'Sam McKnight',
    contactEmail: 'media@sammcknight.co.za',
    category: 'Haircare',
  },
  {
    id: 'brand-114',
    code: '8316',
    name: 'Tangle Teezer',
    contactEmail: 'media@tangleteezer.co.za',
    category: 'Haircare',
  },
  {
    id: 'brand-115',
    code: '8401',
    name: 'Charlotte Mensah',
    contactEmail: 'media@charlottemensah.co.za',
    category: 'Haircare',
  },
  {
    id: 'brand-116',
    code: '8399',
    name: 'Steam Bar',
    contactEmail: 'media@steambar.co.za',
    category: 'Haircare',
  },
  {
    id: 'brand-117',
    code: '8403',
    name: 'Design Me',
    contactEmail: 'media@designme.co.za',
    category: 'Haircare',
  },
  {
    id: 'brand-118',
    code: '3527',
    name: 'Nesti Soaps',
    contactEmail: 'media@nestisoaps.co.za',
    category: 'Other',
  },
  {
    id: 'brand-119',
    code: '1070',
    name: 'Ms London',
    contactEmail: 'media@mslondon.co.za',
    category: 'Other',
  },
  {
    id: 'brand-120',
    code: '9121',
    name: 'Amanda Jayne',
    contactEmail: 'media@amandajayne.co.za',
    category: 'Other',
  },

  // WOOLWORTHS INTERNAL
  {
    id: 'brand-ww',
    code: 'WW',
    name: 'Woolworths Internal',
    contactEmail: 'media@woolworths.co.za',
    category: 'Internal',
  },
]
